var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),(_vm.cart.length > 0 && !_vm.online)?_c('div',{staticClass:"offline-order-counter"},[_vm._v(_vm._s(_vm.cart.length))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offline-indicator"},[_c('p',[_vm._v("Your device has lost internet connectivity")])])
}]

export { render, staticRenderFns }